// extracted by mini-css-extract-plugin
export var dataCell = "_nv-2";
export var dataRow = "_nv-0";
export var headerRow = "_nv-1";